import React from "react";
import "./DropDown.css";

function DropDown({ size, selected, setSelected, menuItems, isActive, setIsActive, label }) {

  let menuRef = React.useRef();

  React.useEffect(() => {
    let handler = (event) => {
      if (!menuRef.current.contains(event.target)) {
        setIsActive(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => {
      document.removeEventListener("mousedown", handler);
    };
  });

  return (
    <div ref={menuRef} className={size === "medium" ? "dropDown dropDownMedium" : "dropDown"}>
      <h5>{label}</h5>
      <div className="dropDown-btn" onClick={() => setIsActive(!isActive)}>
        {selected}
        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#FFFFFF"><path d="M0 0h24v24H0V0z" fill="none" /><path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z" /></svg>
      </div>
      {isActive && (
        <div className="dropDown-content">
          {menuItems.map((item) => (<div key={item} onClick={() => {
            setSelected(item);
            setIsActive(false);
          }} className="dropDown-item" >{item}</div>))}
        </div>
      )}
    </div>
  );
}

export default DropDown;
